import { ref } from 'vue';
import LineStickerPackagesAPI from '../api/lineStickerPackages';

// Default sticker packages (fallback only) - 7组精选LINE贴图
const defaultPackages = [
  {
    packageId: '11539',
    name: 'UNIVERSTAR BT21: Animated Special',
    enabled: true,
    tags: ['bt21', 'animated'],
    stickers: [
      '52114110',
      '52114111',
      '52114112',
      '52114113',
      '52114114',
      '52114115',
      '52114116',
      '52114117',
    ],
  },
  {
    packageId: '11538',
    name: 'CHOCO & Friends: Animated Special',
    enabled: true,
    tags: ['choco', 'animated'],
    stickers: [
      '51626494',
      '51626495',
      '51626496',
      '51626497',
      '51626498',
      '51626499',
      '51626500',
      '51626501',
    ],
  },
  {
    packageId: '11537',
    name: 'Brown & Cony & Sally: Animated Special',
    enabled: true,
    tags: ['brown', 'cony', 'sally'],
    stickers: [
      '52002734',
      '52002735',
      '52002736',
      '52002737',
      '52002738',
      '52002739',
      '52002740',
      '52002741',
    ],
  },
  {
    packageId: '6325',
    name: 'Brown and Cony Fun Size Pack',
    enabled: true,
    tags: ['brown', 'cony', 'fun'],
    stickers: [
      '10979904',
      '10979905',
      '10979906',
      '10979907',
      '10979908',
      '10979909',
      '10979910',
      '10979911',
    ],
  },
  {
    packageId: '6136',
    name: 'Making Amends',
    enabled: true,
    tags: ['amends', 'cute'],
    stickers: [
      '10551376',
      '10551377',
      '10551378',
      '10551379',
      '10551380',
      '10551381',
      '10551382',
      '10551383',
    ],
  },
  {
    packageId: '446',
    name: 'Moon: Special Edition',
    enabled: true,
    tags: ['moon', 'classic'],
    stickers: [
      '1988',
      '1989',
      '1990',
      '1991',
      '1992',
      '1993',
      '1994',
      '1995',
      '1996',
      '1997',
      '1998',
      '1999',
      '2000',
      '2001',
      '2002',
      '2003',
      '2004',
      '2005',
      '2006',
      '2007',
      '2008',
      '2009',
      '2010',
      '2011',
      '2012',
      '2013',
      '2014',
      '2015',
      '2016',
      '2017',
      '2018',
      '2019',
      '2020',
      '2021',
      '2022',
      '2023',
      '2024',
      '2025',
      '2026',
      '2027',
    ],
  },
  {
    packageId: '789',
    name: 'Sally: Special Edition',
    enabled: true,
    tags: ['sally', 'classic'],
    stickers: [
      '10855',
      '10856',
      '10857',
      '10858',
      '10859',
      '10860',
      '10861',
      '10862',
      '10863',
      '10864',
      '10865',
      '10866',
      '10867',
      '10868',
      '10869',
      '10870',
      '10871',
      '10872',
      '10873',
      '10874',
      '10875',
      '10876',
      '10877',
      '10878',
      '10879',
      '10880',
      '10881',
      '10882',
      '10883',
      '10884',
      '10885',
      '10886',
      '10887',
      '10888',
      '10889',
      '10890',
      '10891',
      '10892',
      '10893',
      '10894',
    ],
  },
];

// Global reactive state
const stickerPackages = ref([]);
let isLoaded = false;
let loadPromise = null;

// Load packages from API
const loadPackagesFromAPI = async () => {
  if (loadPromise) {
    return loadPromise;
  }

  if (isLoaded && stickerPackages.value.length > 0) {
    return stickerPackages.value;
  }

  loadPromise = (async () => {
    try {
      console.log('[useLineStickerPackages] Loading packages from API...');
      const response = await LineStickerPackagesAPI.get();

      console.log('[useLineStickerPackages] API response:', response);

      if (response.data && response.data.packages) {
        stickerPackages.value = response.data.packages;
        isLoaded = true;
        console.log(
          '[useLineStickerPackages] Loaded packages:',
          stickerPackages.value
        );
      } else {
        console.warn(
          '[useLineStickerPackages] No packages in response, using defaults'
        );
        stickerPackages.value = [...defaultPackages];
      }
    } catch (error) {
      console.error(
        '[useLineStickerPackages] Error loading packages from API:',
        error
      );
      console.warn('[useLineStickerPackages] Using default packages');
      stickerPackages.value = [...defaultPackages];
    } finally {
      loadPromise = null;
    }

    return stickerPackages.value;
  })();

  return loadPromise;
};

export function useLineStickerPackages() {
  const addPackage = pkg => {
    stickerPackages.value.unshift(pkg);
  };

  const updatePackage = (index, updatedPackage) => {
    stickerPackages.value[index] = updatedPackage;
  };

  const deletePackage = index => {
    stickerPackages.value.splice(index, 1);
  };

  const togglePackage = index => {
    stickerPackages.value[index].enabled =
      !stickerPackages.value[index].enabled;
  };

  const getEnabledPackages = () => {
    return stickerPackages.value.filter(pkg => pkg.enabled);
  };

  const resetToDefaults = () => {
    stickerPackages.value = [...defaultPackages];
  };

  const reloadPackages = () => {
    isLoaded = false;
    return loadPackagesFromAPI();
  };

  return {
    stickerPackages,
    addPackage,
    updatePackage,
    deletePackage,
    togglePackage,
    getEnabledPackages,
    resetToDefaults,
    loadPackagesFromAPI,
    reloadPackages,
  };
}
